var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 76,
    viewBox: "0 0 66 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2605 73.4832C27.4396 72.7192 27.6187 71.9553 30.5601 60.0727C33.5014 48.1902 39.1994 25.2122 42.1636 13.5833C45.1277 1.95442 45.1853 2.3709 45.2128 3.25661C45.2403 4.14232 45.236 5.48462 46.6748 15.9172C48.1136 26.3498 50.9957 45.8319 52.5827 56.0937C54.1698 66.3554 54.3744 66.8064 53.804 66.6116C53.2335 66.4168 51.8817 65.5625 47.7494 62.2347C43.6171 58.9068 36.7451 53.1313 31.9705 49.4635C27.1959 45.7958 24.7269 44.4109 20.3526 42.3656C9.87539 37.4666 2.35118 34.6705 2.32065 34.7305C1.90777 35.542 6.37967 35.8837 10.9143 36.6132C15.4489 37.3426 21.3658 37.9239 29.1432 37.2502C36.9206 36.5764 46.3791 34.6298 51.9596 33.2557C58.9559 31.139 60.8283 29.9334 61.7056 29.1907C62.1693 28.8883 62.6703 28.7371 63.3675 27.8096",
    stroke: "#5DCDF1",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d408bb694430dcfe3f36b367f156a700.svg";
export { ForwardRef as ReactComponent };